export const GET_SUGGESTION = 'GET_SUGGESTION';
export const SET_SUGGESTION = 'SET_SUGGESTION';

export const GET_RECOMMENDATION = 'GET_RECOMMENDATION';
export const SET_RECOMMENDATION = 'SET_RECOMMENDATION';

export const GET_CHART_DATA = 'GET_CHART_DATA';
export const SET_CHART_DATA = 'SET_CHART_DATA';

export const UPDATE_RECOMMENDATION = 'UPDATE_RECCOMMENDATION';